var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionWrapper',{attrs:{"action-button-options":_vm.actionButtonOptions},on:{"action":_vm.openModal},scopedSlots:_vm._u([{key:"sticky",fn:function(){return [_c('span')]},proxy:true}])},[_c('PaymentsTable'),_c('PaymentSystemsModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }